import React from "react";

export default (
  <h1> 
    Hello !
  </h1>
);